<template>
  <integration-smrt-phone is-onboarding-integration/>
</template>

<script>
import {defineComponent} from 'vue'
import IntegrationSmrtPhone from "../../settings/integrations/IntegrationSmrtPhone.vue";

export default defineComponent({
  name: "OnboardingIntegrationSmrtPhone",
  components: {IntegrationSmrtPhone},
})
</script>

<style scoped lang="scss">

</style>
